import styled from 'styled-components';
import { DEVICES, FONT_FAMILY, COLORS } from '@Commons';

export const Container = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${DEVICES.mobileXL} {
    width: 100%;
    padding: 0 14px 0;
  }
`;
export const Title = styled.div`
  font-size: 28px;
  line-height: 38px;
  font-family: ${FONT_FAMILY.hellix.bold};
  text-align: center;
  margin-top: -26px;
  color: ${COLORS.black};
  @media ${DEVICES.mobileXL} {
    margin-top: 0;
  }
`;
export const UploadContainer = styled.div`
  width: 140px;
  margin-top: 25px;
  & > input {
    display: none;
  }
`;
export const ButtonWrapper = styled.div`
  min-width: 100%;
  margin-top: 48px;
  @media ${DEVICES.mobileL} {
    padding: 0 0 32px;
  }
`;
